import gql from 'graphql-tag';

export const SIGN_UP_WITH_ORGANIZATION = gql`
  mutation signUpWithOrganization($input: SignUpWithOrganizationInput!) {
    signUpWithOrganization(input: $input) {
      id
      username
      token
      email
    }
  }
`;

export type SignUpWithOrganizationMutation = {
  signUpWithOrganization: {
    id: string;
    username: string;
    token: string;
    email: string;
  };
};

export type SignUpWithOrganizationUserGender = 'male' | 'female' | 'unknown';
export type SignUpWithOrganizationDocumentType = 'cpf' | 'cnpj';

export type SignUpWithOrganizationVariables = {
  input: {
    username: string;
    birthDate: string; //"1999-07-03"
    gender: SignUpWithOrganizationUserGender;
    email: string;
    password: string;
    // document: string;
    // documentType: SignUpWithOrganizationDocumentType;
    incompleteFlow: boolean;
    phone?: string;
    organizationInfos: {
      organization: {
        contactEmail: string;
        name: string;
        document: string; //cnpj
        address: {
          cep: string;
          address: string;
          number: string;
          neighbourhood: string;
          complement?: string;
          city: string;
          state: string;
        };
      };
      additionalInfos: {
        segment: string;
        plataform: 'vtex' | 'loja_integrada';
      };
      teammates?: {
        emails: string[];
      };
    };
  };
};
